export default "__VITE_ASSET__Da0C437I__"